module.exports = __webpack_public_path__ + "img/D201601_1.9eec6b13.jpg";